import { connect } from 'react-redux';
import { get } from 'lodash';

import { requestFrequencyChange, changeFrequencyInEditMode } from 'apps/subscriptions/actions/subscriptions';
import SubscriptionsFrequencySelect from 'apps/subscriptions/components/fopPartials/SubscriptionsFrequencySelect';

function getRecommendedFrequency(subscriptions, sku) {
  const recommendationsFops = get(subscriptions, 'recommendations[0].fops', []);
  const currentInRecommended = recommendationsFops.find(fop => fop.sku === sku);

  return get(currentInRecommended, 'fopAttributes.subscription_frequency');
}

export default connect(
  (state, ownProps) => {
    const { subscriptions } = state;

    return {
      subscribed: !!get(subscriptions, `subscriptionsBySku['${ownProps.sku}'].quantity`),
      frequency: ownProps.frequency
        || get(subscriptions, `frequenciesBySkuInEditMode['${ownProps.sku}']`)
        || get(subscriptions, `subscriptionsBySku['${ownProps.sku}'].frequency`)
        || getRecommendedFrequency(subscriptions, ownProps.sku)
        || get(subscriptions, 'defaultFrequency'),
    };
  },
  {
    onFrequencyChange: requestFrequencyChange,
    onFrequencyChangeInEditMode: changeFrequencyInEditMode,
  }
)(SubscriptionsFrequencySelect);
